module.exports = __webpack_public_path__ + "media/images/icons/recruitment-tee-5ca6b0ae52f682c0597047d2c17ea2af.svg";